import { NotFoundComponent } from '@citizen/pages/not-found/not-found.component';
import { Routes } from '@angular/router';

import { LoginGuard } from '@citizen/guards/login.guard';
import { inject } from '@angular/core';

export enum RouteNamesEnum {
  Login = 'inicio-sesion',
  MapViewer = 'visor-mapa',
  UserManagement = 'manage-users',
  ManageCameras = 'manage-cameras',
  Reports = 'reports',
  Links = 'links',
  Simac = 'simac',
  observatory = 'observatory',
  RolesManagement = 'manage-roles',
  ManageAudit = 'manage-audit'
}

export const CITIZENRoutes: Routes = [
  {
    path: `${RouteNamesEnum.MapViewer}/:layer`,
    loadChildren: () =>
      import('../pages/map-viewer/map-viewer.module').then(
        (m) => m.MapViewerModule
      ),
    canActivate: [() => inject(LoginGuard).canActivate()]
  },
  {
    // Ruta base, sin parámetro
    path: RouteNamesEnum.MapViewer,
    loadChildren: () =>
      import('../pages/map-viewer/map-viewer.module').then(
        (m) => m.MapViewerModule
      ),
    canActivate: [() => inject(LoginGuard).canActivate()]
  },
  // {
  //   path: RouteNamesEnum.Login,
  //   component: LoginComponent,
  //   canActivate: [LogoutGuard],
  // },
  // {
  //   path: RouteNamesEnum.UserManagement,
  //   loadChildren: () =>
  //     import('../pages/user-management/user-management.module').then(
  //       (m) => m.UserManagmentModule
  //     ),
  //   canActivate: [LoginGuard],
  // },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: RouteNamesEnum.MapViewer,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
